import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppStoreState } from './interfaces/app-store-state';
import { unauthorizedError } from './store/app-actions';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {

	constructor(private store: Store<{app: AppStoreState}>) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req)
			.pipe(
				tap({
					error: (event => {
						if (event instanceof HttpErrorResponse && event.status == 401) {
							this.store.dispatch(unauthorizedError());
						}
					}),
				})
			);
	}

}
